module.exports = __webpack_public_path__ + "img/icon_shopping.e3c1db7c.svg";